// services/adminService.js
import api from './api';

const adminService = {
  /**
   * Get all users with statistics
   */
  async getUsers(params = {}) {
    const queryParams = new URLSearchParams();

    if (params.search) queryParams.append('search', params.search);
    if (params.status) queryParams.append('status', params.status);
    if (params.sortBy) queryParams.append('sortBy', params.sortBy);
    if (params.sortOrder) queryParams.append('sortOrder', params.sortOrder);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.offset) queryParams.append('offset', params.offset);

    return await api.get(`/admin/users?${queryParams.toString()}`);
  },

  /**
   * Get detailed user information
   */
  async getUserDetails(userId) {
    return await api.get(`/admin/users/${userId}`);
  },

  /**
   * Update user status (activate/suspend)
   */
  async updateUserStatus(userId, status) {
    return await api.put(`/admin/users/${userId}/status`, { status });
  },

  /**
   * Update user profile
   */
  async updateUser(userId, userData) {
    return await api.put(`/admin/users/${userId}`, userData);
  },

  /**
   * Delete user account
   */
  async deleteUser(userId) {
    return await api.delete(`/admin/users/${userId}`);
  },

  /**
   * Get system statistics
   */
  async getStats() {
    return await api.get('/admin/stats');
  }
};

export default adminService;
